import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  gitlabAuthApiRef,
  oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import { GitlabAuth } from '@backstage/core-app-api';
import {
  matlabVncSessionApiRef,
  MatlabVncSessionClient,
} from './components/matlab/matlabVncSessionApi';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: matlabVncSessionApiRef,
    deps: {},
    factory: () => new MatlabVncSessionClient(),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: gitlabAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      GitlabAuth.create({
        discoveryApi,
        oauthRequestApi,
        configApi,
        environment: configApi.getOptionalString('auth.environment') ?? 'development',
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
